<main class="pv2-global-additional">
  <header class="pv2-global-additional__header" *ngIf="!loading && group">
    <button type="button" class="pv2-global-additional__back" (click)="goBack()">
      <span class="fa fa-arrow-left"></span>
      <span>Adicionais</span>
    </button>

    <div class="pv2-global-additional__identity">
      <span class="pv2-global-additional__eyebrow">Editor de adicional</span>
      <div class="pv2-global-additional__title-row">
        <h1>{{ group.name }}</h1>
        <span class="pv2-global-additional__requirement" [class.is-optional]="!isRequired">
          {{ isRequired ? 'Obrigatório' : 'Opcional' }}
        </span>
        <span class="pv2-global-additional__usage"
              [class.is-exclusive]="sharedProductNames.length === 1"
              [class.is-shared]="sharedProductNames.length > 1">
          {{ usageLabel }}
        </span>
      </div>
      <p>{{ group.description }} · {{ group.options.length }} {{ group.options.length === 1 ? 'opção' : 'opções' }}</p>
    </div>

    <div class="pv2-salvamento" [class.is-pendente]="temAlteracaoPendente"
         [class.is-salvando]="estadoSalvamento === 'saving'">
      <span class="pv2-salvamento__estado" role="status">
        <span class="pv2-salvamento__ponto" aria-hidden="true"></span>
        {{ rotuloSalvamento }}
      </span>
      <button type="button" class="pv2-salvamento__btn" *ngIf="temAlteracaoPendente"
              (click)="salvarAgora()">
        Salvar agora
      </button>
    </div>
  </header>

  <!-- Renderiza mesmo sem vínculo nenhum: é justamente o caso que mais precisa da ação. -->
  <section class="pv2-global-additional__impact"
           [class.is-alerta]="sharedProductNames.length > 1"
           *ngIf="!loading && group">
    <div>
      <span class="fa" [ngClass]="iconeVinculo"></span>
      <div>
        <strong>{{ tituloVinculo }}</strong>
        <p>{{ textoVinculo }}</p>
      </div>
      <button type="button" class="pv2-global-additional__vincular"
              [disabled]="!canEditStructure"
              [attr.title]="canEditStructure ? null : 'A estrutura dos adicionais é controlada pelo catálogo da rede.'"
              (click)="abraSeletor()">
        <span class="fa fa-link"></span>
        Vincular a produtos
      </button>
    </div>
    <div class="pv2-global-additional__product-chips" *ngIf="sharedProductNames.length">
      <span *ngFor="let name of sharedProductNames"><span class="fa fa-cube" aria-hidden="true"></span>{{ name }}</span>
    </div>
  </section>

  <div class="pv2-overlay-vinculo" *ngIf="seletorAberto" (click)="fecheSeletor()"></div>
  <aside class="pv2-folha-vinculo" *ngIf="seletorAberto" role="dialog" aria-modal="true"
         aria-labelledby="pv2-folha-vinculo-titulo">
    <header class="pv2-folha-vinculo__topo">
      <div>
        <h2 id="pv2-folha-vinculo-titulo">Vincular a produtos</h2>
        <p>{{ group?.name }} passa a aparecer nos produtos marcados. É o mesmo grupo, não uma cópia.</p>
      </div>
      <button type="button" class="pv2-folha-vinculo__fechar" (click)="fecheSeletor()" aria-label="Fechar">
        <span class="fa fa-times"></span>
      </button>
    </header>

    <div class="pv2-folha-vinculo__corpo">
      <app-seletor-produtos-v2 *ngIf="!resultadoVisivel"
        [empresa]="empresa"
        [jaVinculados]="idsVinculados"
        [podeEditar]="canEditStructure"
        [ocupado]="vinculando"
        rotuloAcao="Vincular a"
        (confirmou)="vinculeAosProdutos($event)"
        (cancelou)="fecheSeletor()">
      </app-seletor-produtos-v2>

      <div class="pv2-resultado-vinculo" *ngIf="resultadoVisivel">
        <div class="pv2-resultado-vinculo__ok" *ngIf="vinculadosComSucesso">
          <span class="fa fa-check-circle"></span>
          <div>
            <strong>{{ vinculadosComSucesso }} {{ vinculadosComSucesso === 1 ? 'produto vinculado' : 'produtos vinculados' }}</strong>
            <p *ngIf="virouCompartilhado">
              A partir de agora, editar este grupo muda os {{ sharedProductNames.length }} produtos.
            </p>
          </div>
        </div>

        <div class="pv2-resultado-vinculo__falhas" *ngIf="vinculosFalhos.length">
          <strong>{{ vinculosFalhos.length }} {{ vinculosFalhos.length === 1 ? 'produto ficou' : 'produtos ficaram' }} sem o vínculo</strong>
          <ul>
            <li *ngFor="let falha of vinculosFalhos">
              <span class="pv2-resultado-vinculo__produto">{{ falha.product.name }}</span>
              <span class="pv2-resultado-vinculo__motivo">{{ falha.error }}</span>
            </li>
          </ul>
        </div>

        <div class="pv2-resultado-vinculo__acoes">
          <button type="button" class="pv2-ghost-btn" (click)="fecheSeletor()">Fechar</button>
          <button type="button" class="pv2-ghost-btn" *ngIf="vinculosFalhos.length"
                  [disabled]="vinculando" (click)="tenteVinculosFalhos()">
            <span class="fa fa-spinner fa-spin" *ngIf="vinculando"></span>
            Tentar de novo
          </button>
          <button type="button" class="pv2-primary-btn" (click)="voltarAoSeletor()">Vincular a mais</button>
        </div>
      </div>
    </div>
  </aside>

  <section class="pv2-global-additional__loading" *ngIf="loading">
    <span class="fa fa-spinner fa-spin"></span>
    <p>Carregando adicional...</p>
  </section>

  <section class="pv2-global-additional__error" *ngIf="!loading && errorMessage">
    <span class="fa fa-exclamation-circle"></span>
    <h2>Não foi possível abrir o adicional</h2>
    <p>{{ errorMessage }}</p>
    <div>
      <button type="button" (click)="goBack()">Voltar</button>
      <button type="button" class="is-primary" (click)="load()">Tentar novamente</button>
    </div>
  </section>

  <section class="pv2-global-additional__editor" *ngIf="!loading && !errorMessage && editor && group">
    <app-tela-editor-adicional-v2
      [standalone]="true"
      [editor]="editor"
      [empresa]="empresa"
      [podeEditar]="canEditStructure"
      [podeEditarPrecos]="canEditPrices"
      [podeEditarDisponibilidade]="canEditAvailability"
      [podeEditarExibicaoOpcoes]="canEditOptionDisplay"
      [groupId]="group.id"
      [mode]="'edit'"
      [requestedOptionMode]="requestedOptionMode"
      (closeRequested)="goBack()"
      (actionBarStateChange)="onEstadoSalvamento($event)"
      (groupSaved)="onGroupSaved($event)"
      (groupDeleted)="onGroupDeleted()">
    </app-tela-editor-adicional-v2>
  </section>

</main>
